import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Table } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import imgcontact from '../../../../assets/images/contact.jpg'
import icons01 from '../../../../assets/images/icons/contact/iCON-01.svg'
import icons02 from '../../../../assets/images/icons/contact/iCON-02.svg'
import icons03 from '../../../../assets/images/icons/contact/iCON-03.svg'
import icons04 from '../../../../assets/images/icons/contact/iCON-04.svg'
// import icons01 from '''
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import { workforce, getToken } from '../../../../utils/auth';
import axios from 'axios';
import { apiKeyNews } from '../../../../utils/apiKey'

const { Text, Title } = Typography

class DashBoradEmpList extends React.Component {

    state = {
        dataContact: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        columns: [
            {
                title: 'ชื่องาน',
                dataIndex: 'divisionName',
                render: (item, record, index) => <span>{item}</span>
            },
            {
                title: 'ตำแหน่ง',
                dataIndex: 'position',
                render: (item, record, index) => <span>{item}</span>
            },
            
            {
                title: 'ชื่อ',
                dataIndex: 'name',
                render: (item, record, index) => <span>{item}</span>
            },
            {
                title: 'เบอร์โทรศัพท์',
                dataIndex: 'telNo',
                render: (item, record, index) => <span>{item}</span>
            },
            {
                title: 'เบอร์ติดต่อที่ทำงาน',
                dataIndex: 'telNoExtra',
                render: (item, record, index) => <span>{item}</span>
            },
            {
                title: 'อีเมล',
                dataIndex: 'email',
                render: (item, record, index) => <span>{item}</span>
            },
        ],
        dataContactUsTelDivision: [],
    }

    fetchContact = async () => {
        const { client, match, location } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListContactUs,
            variables: {
                contactUsId: location.pathname.split('/')[4]
            }
            
        })
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        await this.setState({
            dataContact: data.fetchListContactUs
        })

        if(data.fetchListContactUs[0].contactUsTelDivision !== 0){
            this.setState({
                dataContactUsTelDivision: data.fetchListContactUs[0].contactUsTelDivision
            })
        }
    }

    getEmpList = async (mode, orgUnitCode, empCode, empName) => {
      const { token } = getToken();
      const { approverId, dataProfile } = this.state
      const { match, location } = this.props;
      const API_DEVICE_KEY = atob(apiKeyNews());

      await this.setState({
      loadingFullpage: true,
      });

      const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
      };

      axios
      .get(
         `${workforce()}/getEmpList`,
         {
            params: {
               orgUnitCode,
               page: 1,
               pageSize: 999999,
               mode,
               empCode,
               empName
             },
            headers: headers
         }
      )
      .then(async (response) => {
         console.log('12312312312', response)
         // const statusApproves = response.data.data.tbApprover.find(detail => detail.approverId == approverId)
         
         await this.setState({
            dataContact: response.data.data.empList,
            preLoadShow:true
         });
      })
      .catch((error) => console.error(`Error: ${error}`));
   };

      async componentDidMount() {
         const { modeSearch, orgUnitID, empCode, empName } = this.props;
      }


    render() {
        const { match, dataContact } = this.props
      //   const { dataContact, dataContactUsTelDivision, columns } = this.state
         const { dataContactUsTelDivision, columns } = this.state

         console.log('dataContact', dataContact)
        return (
                     <Row gutter={20} className="mt-4">
                        {
                           dataContact.length !== 0 &&
                              dataContact.map((value) =>
                                 <Card className="mb-3">
                                    <Col xs={24}>
                                          {value.contactUsTitle &&
                                             <div className="mb-3">
                                                <strong className="color-black">
                                                      {value.contactUsTitle}
                                                </strong>
                                             </div>
                                          }
                                         
                                             <div className="mb-3">
                                                <strong className="color-black">
                                                      { value.positionManageName ? value.positionManageName : value.positionName ? value.positionName : '-' }
                                                </strong>
                                             </div>

                                             <Row gutter={20} className="mb-3">
                                                <Col xs={3} md={2} align="center">
                                                <img src={icons01} style={{ maxWidth: '100%', height: '30px' }} />
                                                </Col>
                                                <Col xs={21} md={20} className="pt-1">
                                                      {/* <div dangerouslySetInnerHTML={{ __html: value.empName }}></div> */}
                                                      <p className="mb-0">
                                                         { value.empName ? value.empName : '-' }
                                                      </p>
                                                </Col>
                                             </Row>

                                             {/* {
                                                value.phone && */}
                                                   <Row gutter={20} className="mb-3">
                                                      <Col xs={3} md={2} align="center">
                                                      <img src={icons02} alt="logo" style={{ maxWidth: '100%', height: '30px' }} />
                                                      </Col>
                                                      <Col xs={21} md={20} className="pt-1">
                                                            <p className="mb-0">{ value.phone ? value.phone : '-'}</p>
                                                      </Col>
                                                   </Row>
                                             {/* } */}
                                            
                                            {/* {
                                                value.phoneWork && */}
                                                   <Row gutter={20} className="mb-3">
                                                      <Col xs={3} md={2} align="center">
                                                            {/* <Icon type="phone" className="color-orange" /> */}
                                                      <img src={icons03} style={{ maxWidth: '100%', height: '30px' }} />
                                                      </Col>
                                                      <Col xs={21} md={20} className="pt-1">
                                                            {/* <div dangerouslySetInnerHTML={{ __html: value.phoneWork }}></div> */}
                                                            <p>{ value.phoneWork ? value.phoneWork : '-' }</p>
                                                      </Col>
                                                   </Row>
                                            {/* } */}
{/* 
                                            {
                                                value.email && */}
                                                <Row gutter={20} className="mb-3">
                                                   <Col xs={3} md={2} align="center">
                                                         {/* <Icon type="mail" className="color-orange" /> */}
                                                   <img src={icons04} style={{ maxWidth: '100%', height: '30px' }} />
                                                   </Col>
                                                   <Col xs={21} md={20} className="pt-1">
                                                         {/* <div dangerouslySetInnerHTML={{ __html: value.email }}></div> */}
                                                         <p className="mb-0"> { value.email ? value.email : '-' } </p>
                                                   </Col>
                                                </Row>
                                            {/* } */}
                                             
                                          {
                                             dataContactUsTelDivision.length !== 0 &&
                                             <Table
                                                columns={columns}
                                                dataSource={dataContactUsTelDivision}
                                                pagination={{ pageSize: [ 500 ] , position :['none'] }}
                                             />
                                          }
                                       
                                    </Col>
                                 </Card>
                              )
                              ||
                                  <div style={{ textAlign:"center" }}>
                                    <Text className="color-gray" >ไม่พบข้อมูล</Text>
                                 </div>
                        }
                     </Row>
        )
    }
}

DashBoradEmpList.propTypes = {
    //
}

export default withApollo(DashBoradEmpList)